/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_File_Tree_Toast_Error_All_FailedInputs */

const es_components_file_tree_toast_error_all_failed = /** @type {(inputs: Components_File_Tree_Toast_Error_All_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archivos fallaron durante la ingesta`)
};

const en_components_file_tree_toast_error_all_failed = /** @type {(inputs: Components_File_Tree_Toast_Error_All_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files failed during ingestion`)
};

/**
* | output |
* | --- |
* | "{count} files failed during ingestion" |
*
* @param {Components_File_Tree_Toast_Error_All_FailedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_toast_error_all_failed = /** @type {((inputs: Components_File_Tree_Toast_Error_All_FailedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Toast_Error_All_FailedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_toast_error_all_failed(inputs)
	return en_components_file_tree_toast_error_all_failed(inputs)
});
export { components_file_tree_toast_error_all_failed as "components.file_tree.toast_error_all_failed" }